import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  Stepper,
  Step,
  StepLabel,
  Box,
  makeStyles,
  createStyles,
  Divider,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { ReactComponent as Return } from '../../assets/icons/Return.svg'
import { PACKAGE_INFO } from 'src/utils/constant'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles((theme) =>
  createStyles({
    icon: {
      flexShrink: 0,
      width: theme.spacing(3),
      height: theme.spacing(3),
      '& path': {
        width: theme.spacing(1.75),
        height: theme.spacing(1.75),
        fill: theme.palette.grey[800],
      },
    },
    back: {
      cursor: 'pointer',
      borderRadius: '100px',
      height: '56px',
      fontSize: 16,
      [theme.breakpoints.down('xs')]: {
        width: '100px',
        height: '40px',
        fontSize: 14,
      },
    },
    activeStepIcon: {
      color: theme.palette.secondary.main,
      '& path': {
        fill: theme.palette.secondary.main,
      },
    },
    label: {
      fontSize: '18px',
    },
    vertical: {
      border: 'red',
    },
  }),
)

const steps = [
  'common.select_site',
  'common.select_date',
  'common.select_doctor',
  'glossary.appointment_detail',
]

const ClinicStep = ({ step }) => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const history = useHistory()
  const { selectedDoctor } = useSelector((state) => state.testCenter)
  const [value, setValue] = useState(selectedDoctor?.package ? selectedDoctor?.package : '1')

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const [activeStep, setActiveStep] = useState(step || 0)
  // console.log(setActiveStep)
  useEffect(() => {
    setValue(selectedDoctor?.package)
    setActiveStep(step)
  }, [step])
  return (
    <>
      <Box
        mt={1}
        color="primary.main"
        fontSize={14}
        fontWeight={700}
        border="1px solid #E5E7EB"
        borderRadius="100px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        width={isMobile ? '80px' : '272px'}
        className={classes.back}
        onClick={() => {
          history.push(`/${i18n.language}` + PACKAGE_INFO[value].path, { pack: value })
        }}
      >
        <Return />
        {t('common.page_hone')}
      </Box>
      <Box mt={3}>
        <Divider />
      </Box>
      <Stepper activeStep={activeStep} orientation="vertical" connector={<Box my={3} />}>
        {steps.map((label, index) => {
          return (
            <Step
              key={label}
              classes={{
                completed: classes.activeStepIcon,
                active: classes.activeStepIcon,
              }}
            >
              <StepLabel
                classes={{
                  label: classes.label,
                }}
              >
                {t(label)}
              </StepLabel>
            </Step>
          )
        })}
      </Stepper>
    </>
  )
}

export default ClinicStep
